import { render, staticRenderFns } from "./fccCidadesDeProvasRelacionadasAConfiguracao.vue?vue&type=template&id=68732912"
import script from "./fccCidadesDeProvasRelacionadasAConfiguracao.vue?vue&type=script&lang=js"
export * from "./fccCidadesDeProvasRelacionadasAConfiguracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports